import { FC } from "react";
import { useTranslations } from "../hooks/useTranslations.ts";
import { translationKeys } from "../translations/translationKeys.ts";
import ThankYouScreenWrapper, { ThankYouScreenProps } from "./ThankYouScreenWrapper.tsx";

const AccountAlreadyExistsScreen: FC<ThankYouScreenProps> = (props) => {
  const { translate } = useTranslations();

  return (
    <ThankYouScreenWrapper {...props} title={translate(translationKeys.EXISTING_ACCOUNT_TITLE)}>
      <p>{translate(translationKeys.EXISTING_ACCOUNT_MESSAGE)}</p>
    </ThankYouScreenWrapper>
  );
};

export default AccountAlreadyExistsScreen;
